/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

export const listQuestions = (questions, tag = "[listQuestions]") => {
    for (const question of questions) {
        const key = question.key;
        const position = question.position;
        // let label = question.prompt;
        // console.info(`${tag} question [position:${position}] [key:${key}] ${label}`);
        console.info(`${tag} question [position:${position}] [key:${key}]`);
    }
};
